import React, {useEffect, useState} from 'react';

import { getSiblingsData } from '../DropdownDataProviders' ;
import { renderDropdown, renderDropdownReadOnly} from "../DropdownFunctions";

import SpinnerDiv from "../SpinnerDiv";
import PropTypes from "prop-types";

const DropdownSiblingSelect = (props ) =>
{
    const [ data, setData ] = useState ( { loading: true, items : [] } ) ;

    useEffect(() => {
        getSiblingsData(false).then (response =>
        {
            setData ( { loading: false, items: response }) ;
        })

    }, []);

    return data.loading === true ? <SpinnerDiv/> :
    (
        props.readOnly === 'readonly' ? renderDropdownReadOnly(props, data) : renderDropdown(props, data)
    )
}

export default DropdownSiblingSelect;

DropdownSiblingSelect.defaultProps =
{
    defaultClassName: 'form-group'
}

DropdownSiblingSelect.propTypes = {
    onChange: PropTypes.func.isRequired
};